import {DragulaOptions, DragulaService} from 'ng2-dragula';
import {Observable} from 'rxjs';
import {Observed} from './observed.interface';
import {IResourceJson} from 'src/app/diagram-data/diagram-json-handler.service';

export type DragulaWithOptions<T> = {groupName: string} & DragulaOptions<T>;

type DragulaEventName = {
  [K in keyof DragulaService]: DragulaService[K] extends (...args: any[]) => Observable<any>
    ? K
    : never;
}[keyof DragulaService];

export type DragulaEvent<TEvent extends DragulaEventName> = Observed<
  ReturnType<DragulaService[TEvent]>
>;

export interface DragElement extends HTMLElement {
  dataset: {
    dragMetadata: string;
    dragShadow?: string;
    isCopied: '0' | '1';
  };
}

export const DRAGULA_BAG_PREFIXES = {
  ACTIVITY: 'actBag',
  INTERACTION: 'interactionBag',
  LEGEND_ITEM: 'legendItemsBag',
  RESOURCE: 'resBag',
  SWIMLANES: 'swimlanes-bag',
  ACTIVITIES: 'activities-bag'
} as const;

export type BagPrefix = (typeof DRAGULA_BAG_PREFIXES)[keyof typeof DRAGULA_BAG_PREFIXES];

export function isDragElement(el: Element): el is DragElement {
  return el instanceof HTMLElement && el.dataset.isCopied !== undefined;
}

export const DRAGULA_BAG_OPTIONS: Partial<Record<BagPrefix, DragulaOptions>> = {
  actBag: {
    copyItem: (item: IResourceJson) => ({...item}),
    direction: 'vertical',
    moves: (el, src, handle, sibling) =>
      Boolean(handle?.classList && handle.classList.contains('drag-item-handle')),
    copy: () => true,
    accepts: (el, target, source, sibling) =>
      Boolean(target !== source && Number(target?.attributes['allow-drop'].nodeValue))
  },
  resBag: {
    copy: false,
    moves: (..._: any[]) => true,
    direction: 'vertical'
  }
};
